import { Elements } from '@stripe/react-stripe-js';
import { loadStripe } from '@stripe/stripe-js';
import React, { useEffect, useState } from 'react';

import { SubscriptionFormProps } from '.';
import { STRIPE_PUBLISH_KEY } from '../../src/env';
import { createSetupIntent } from '../../utils/backend-api/stripe';
import { Spinner } from '../BaseUI';
import PaymentMethod from './PaymentMethod';

const stripePromise = loadStripe(STRIPE_PUBLISH_KEY);
const PaymentForm = ({
  buttonText,
  currentTrialEndDate,
  isUserCBPT,
  referringSubscriberName,
  referringSubscriberGuid,
  selectedOffer,
  stripeCustomerId,
  userNextBillingDate,
}: SubscriptionFormProps) => {
  const [clientSecret, setClientSecret] = useState('');
  const isTrial = !!referringSubscriberName;

  useEffect(() => {
    (async () => {
      const { client_secret: clientSecret } = await createSetupIntent({
        stripe_customer_id: stripeCustomerId,
      });
      setClientSecret(clientSecret);
    })();
  }, [stripeCustomerId]);

  return (
    <>
      {clientSecret ? (
        <Elements stripe={stripePromise} options={{ clientSecret }}>
          <PaymentMethod
            buttonText={buttonText}
            selectedOffer={selectedOffer}
            currentTrialEndDate={currentTrialEndDate}
            isTrial={isTrial}
            isUserCBPT={isUserCBPT}
            referringSubscriberName={referringSubscriberName}
            referringSubscriberGuid={referringSubscriberGuid}
            userNextBillingDate={userNextBillingDate}
          />
        </Elements>
      ) : (
        <div className="tw-text-center tw-my-16">
          <Spinner />
        </div>
      )}
    </>
  );
};

export default PaymentForm;
